import { useRating } from '@risksmart-app/components/src/hooks/useRating';
import type { ContentTable } from 'pdfmake/interfaces';
import type { GetStandardFormFieldLabel } from 'src/hooks/forms/useFormCustomisation';
import { useLazyGetObligationOversightResultsByObligationId } from 'src/hooks/queries';
import { UNRATED } from 'src/pages/controls/lookupData';

import { toLocalDate } from '@/utils/dateUtils';
import { createTable, tableHeaders } from '@/utils/pdf/table';

const useOversightAssessmentsExportTable = (
  obligationId: string,
  getStandardFieldLabel: GetStandardFormFieldLabel
): [() => Promise<ContentTable>, boolean] => {
  const { getLabel: getStatusLabel } = useRating('assessment_status');
  const { getLabel: getResultLabel } = useRating('performance_result');
  const [getAssessments, getAssessmentsResult] =
    useLazyGetObligationOversightResultsByObligationId();

  const createExportTable = async () => {
    const { data: assessmentsData } = await getAssessments({ obligationId });
    const assessmentsTableData = (
      assessmentsData?.obligation_oversight_result ?? []
    ).map((au) => [
      au.parents[0].oversightAssessment?.Title ?? '-',
      getStatusLabel(au.parents[0].oversightAssessment?.Status ?? '-'),
      getResultLabel(au.Rating ?? UNRATED.value),
      toLocalDate(au.parents[0].oversightAssessment?.StartDate),
      toLocalDate(au.parents[0].oversightAssessment?.ActualCompletionDate),
      au.parents[0].oversightAssessment?.completedByUser?.FriendlyName ?? '-',
    ]);

    return createTable({
      widths: '*',
      body: [
        tableHeaders([
          getStandardFieldLabel('oversight_assessment', 'Title'),
          getStandardFieldLabel('oversight_assessment', 'Status'),
          getStandardFieldLabel('obligation_oversight_result', 'Rating'),
          getStandardFieldLabel('oversight_assessment', 'StartDate'),
          getStandardFieldLabel('oversight_assessment', 'ActualCompletionDate'),
          getStandardFieldLabel('oversight_assessment', 'CompletedByUser'),
        ]),
        ...assessmentsTableData,
      ],
    });
  };

  return [createExportTable, getAssessmentsResult.loading];
};

export default useOversightAssessmentsExportTable;
